import React, { useEffect, useState } from "react";
import backImg from "../../../common/assests/backImg.png";
import { Box, Grid, Menu, MenuItem, Modal, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import EditIcon from "../../../common/assests/editicon.png";
import Message from "../../../common/assests/message.svg";
import More from "../../../common/assests/more.svg";
import DeleteIcon from "../../../common/assests/deleticon.png";
import PeopleIcon from "../../../common/assests/people.svg";
import FavoriteIcon from "@mui/icons-material/Favorite";
import Clock from "../../../common/assests/clock.svg";
import ReyLeaf from "../../../common/assests/reyleafLogo.svg";
import { allUserCommentsDataApi, deleteForumApi, getAllModerationForumPost, postDeleteApi, updateFourmApi } from "../../../api";
import { useSelector } from "react-redux";
import Loader from "../../../common/loader/Loader";
import UserImg from "../../../common/assests/sampleuser.svg";
import CommentModal from "../../../common/customModal/CommentModal";
import { toast } from "react-toastify";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import ForumModal from "../ForumModal";
import configuration from "../../../config/Config";

const ModrationDetail = () => {

  const token = useSelector((state) => state?.user?.user?.token);
  const navigate = useNavigate();
  const location = useLocation();
  const [event, setEvent] = useState(location.state?.event || {});
  const [postData, setPostData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [opens, setOpens] = useState(false);
  const [change, setChange] = useState(false);
  const [postID, setPostId] = useState(null);
  const [commentModalOpen, setCommentModalOpen] = useState(false);
  const [selectedComment, setSelectedComment] = useState(null);
  const [editingData, setEditingData] = useState(null);
  
  const [commentData,setCommentData]=useState([]);
  const [commentCurrentPage, setCommentCurrentPage] = useState(1);
  const [commentTotalPages, setCommentTotalPages] = useState(0);
  
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);


// edit modal open
  const handleClickForumOpen = (data) => {
    setEditingData(data||null);
    setOpens(true);
  };
  const handleForumClose = () => {
    setOpens(false);
  };

  // commnet modal open
  
  const handleModalOepn = (comment) => {
    setPostId(comment?._id)
    handleCommentDetails(comment?._id)
    setCommentModalOpen(true);
  };
  const handleModalClose = () => {
    setCommentModalOpen(false);
  };


  const handleClick = (e, id) => {
    setPostId(id);
    setAnchorEl(e.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };


// fetch all post
  const handlePost = async () => {
    try {
      setLoading(true);
      const response = await getAllModerationForumPost({
        token,
        id: event?._id,
      });
      setPostData(response?.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("errror", error);
    }
  };
  useEffect(() => {
    handlePost();
  }, [change]);

// update forum details

  const handleSave = async (forumData, id) => {
    try {
        if(!forumData.title || !forumData.description){
          toast.warning("Title and description required")
          return
        }
        const response = await updateFourmApi({ token, forumData, id });
        setEvent((prevEvent) => ({
          ...prevEvent,
          title: response?.data?.title,
          description: response?.data?.description,
        }));   
        toast.success(response?.message);
        handleForumClose()
    } catch (error) {
      toast.error(error?.message);
      console.error("Error saving forum", error);
    }
  };

  // delete forum
  const handleDeleteForum = async (id) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this Forum?"
    );
    if (!confirmed) {
      return;
    }
    try {
      const response = await deleteForumApi({ token, id });
      toast.success(response?.message);
      // navigate("")
      navigate(-1);
    } catch (error) {
      toast.error(error.message);
      console.log("errror", error);
    }
  };

  // delete post
  const handleDeletePost = async (id) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this post?"
    );
    if (!confirmed) {
      return;
    }
    try {
      const response = await postDeleteApi({ token, id });
      toast.success(response?.message);
      setChange(!change)
    } catch (error) {
      toast.error(error.message);
      console.log("errror", error);
    }
  };



  const handleCommentDetails = async (id) => {
    try {
      const response = await allUserCommentsDataApi({
        token,
        id, // Post ID
       commentCurrentPage, 
      });

      setCommentData((prev) => [
        ...prev,
        ...(response?.comment || []),
      ]);
      setCommentTotalPages(response?.totalPages || 1);
      setCommentCurrentPage(response?.currentPage || 1); 
    } catch (error) {
      {
        if (error?.status === 500) {
          toast.error("Some error occured");
        } else {
          toast.error(error?.error||error?.message);
        }
        console.log("error", error);
      }
      console.log("error", error);
    }
  };
  
  useEffect(() => {
    if (postID) {
      handleCommentDetails(postID);
    }
  }, [commentCurrentPage]);

  const loadMoreTickets = () => {
    if (commentCurrentPage < commentTotalPages) {
      setCommentCurrentPage((prevPage) => prevPage + 1);
    }
  };
  
  const hasMoreTickets = commentCurrentPage < commentTotalPages;

  return (
    <div style={{ maxWidth: "1420px" }}>
      {loading ? (
        <Loader variant="grid" />
      ) : (
        <>
          <Box sx={{ paddingLeft: "10px" }}>
            <Typography
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "start",
                gap: "15px",
                width: "8%",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={()=>navigate(-1)}
            >
              <img
                src={backImg}
                alt="backImg"
                style={{ height: "29px", width: "29px" }}
              />
              <Typography
                sx={{ color: "#065F46", fontWeight: "500", fontSize: "20px" }}
              >
                Back
              </Typography>
            </Typography>
          </Box>

          <Box
            sx={{
              marginTop: "20px",
              borderRadius: "36px",
              backgroundColor: "#FFF",
              boxShadow: "3px 2px 20px 0px rgba(0, 0, 0, 0.04)",
              maxWidth: "1460px",
              width: "100%",
              flexShrink: 0,
              padding: "20px",
            }}
          >
            <Box
              component="img"
              src={
                event?.picture
                  ? `${configuration.cdnFront}/${event?.picture}`
                  : ReyLeaf
              }
              alt="event image"
              sx={{
                width: "100%",
                height: { xs: "150px", sm: "200px", md: "250px", lg: "270px" },
                borderRadius: "20px",
              }}
            />

            <Grid
              container
              justifyContent="space-between"
              alignItems="center"
              sx={{ marginTop: "30px" }}
            >
              <Typography
                sx={{
                  color: "#362B24",
                  fontFamily: "Heebo",
                  fontWeight: "600",
                  fontSize: { xs: "4vw", sm: "3vw", md: "1.5vw", lg: "20px" },
                }}
              >
                {event?.title || "N/A"}
              </Typography>
              <Box sx={{ display: "flex" }}>
                <Typography
                  onClick={() => handleClickForumOpen(event)}
                  sx={{
                    color: "#EA001B",
                    cursor: "pointer",
                    marginRight: "10px",
                  }}
                >
                  <img src={EditIcon} alt="Edit" />
                </Typography>
                <Typography
                  onClick={() => handleDeleteForum(event?._id)}
                  sx={{ color: "#EA001B", cursor: "pointer" }}
                >
                  <img src={DeleteIcon} alt="Delete" />
                </Typography>
              </Box>
            </Grid>

            <Typography
              sx={{
                fontFamily: "Heebo",
                color: "#065F46",
                fontWeight: "400",
                display: "flex",
                gap: "5px",
                fontSize: "12px",
              }}
            >
              <img
                src={PeopleIcon}
                alt="img"
                style={{ width: "17px", height: "17px" }}
              />
              <span>{event?.members?.length || "0"} Members</span>
            </Typography>

            <Typography
              sx={{
                marginTop: "20px",
                color: "#362B24",
                opacity: "0.8",
                fontFamily: "Heebo",
                fontSize: { xs: "3vw", sm: "2vw", md: "1.2vw", lg: "13px",xl:"16px" },
              }}
            >
              {event?.description||"N/A"}
            </Typography>
          </Box>

          <Typography
            sx={{
              color: "#362B24",
              fontFamily: "Heebo",
              fontWeight: "600",
              marginTop: "20px",
              fontSize: { xs: "4vw", sm: "3vw", md: "1.5vw", lg: "22px" },
              paddingLeft: "10px",
            }}
          >
            All User Posts
          </Typography>

          {postData?.memberFeeds?.length > 0 ? (
            postData?.memberFeeds?.map((item) => (
              <Grid container spacing={2} mb={10}>
                <Grid item xs={12} sm={6} md={4} key={item?._id}>
                  {/* <Box mb={4}
               sx={{
                 width: "100%",
                 maxWidth: "449px",
                 height: "auto",
                 flexShrink: 0,
                 borderRadius: "22px",
                 backgroundColor: "#FFF",
                 boxShadow: "1px 2px 30px 0px rgba(0, 0, 0, 0.06)",
                 display: "flex",
                 flexDirection: "column",
                 padding: "16px",
                 marginTop: "25px",
               }}
             >
               <Box
                 sx={{
                   display: "flex",
                   flexDirection: "row",
                   alignItems: "flex-start",
                   marginBottom: "10px",
                 }}
               >
                 <img
                   src={item?.userDetails?.picture ? `${configuration.cdnFront}/${item?.userDetails?.picture}`:UserImg}
                   alt="User"
                   style={{
                     borderRadius: "13px",
                     marginRight: "12px",
                     width: "45px",
                     height: "45px",
                     objectFit: "cover",
                   }}
                 />
                 <Box>
                   <Typography
                     sx={{
                       fontWeight: "700",
                       fontSize: "14px",
                       color: "#362B24",
                     }}
                   >
                     {item?.userDetails?.fullname||"N/A"}
                   </Typography>
                   <Typography
                     sx={{
                       fontSize: "11px",
                       color: "#065F46",
                       fontWeight: "400",
                       marginTop: "5px",
                     }}
                   >
                     <img
                       src={Clock}
                       className="me-2"
                       style={{ fontFamily: "Heebo" }}
                     />
                     {item?.updated_at ? new Date(item.updated_at).toLocaleDateString("en-GB", {
                        day: "numeric",
                        month: "short",
                        year: "numeric"
                      }): "-"}
                   </Typography>
                 </Box>
               </Box>
 
               <Typography
                 sx={{
                   fontSize: "13px",
                   color: "#362B24",
                   marginBottom: "10px",
                   opacity: 0.6,
                   fontFamily: "Heebo",
                   lineHeight: "24px",
                 }}
               >
                 {item?.description||"N/A"}
               </Typography>
 
               <Box
                 sx={{
                   fontSize: "12px",
                   color: "#362B24",
                   display: "flex",
                   justifyContent: "space-between",
                   alignItems: "center",
                 }}
               >
                 <Typography
                   sx={{
                     display: "flex",
                     alignItems: "center",
                     flexWrap: "wrap",
                     gap: 1,
                     fontFamily: "Heebo",
                     fontWeight: 400,
                     fontSize: "14px",
                   }}
                 >
                   <FavoriteIcon sx={{ color: "red" }} />
                   <span>{item?.likeCount||"0"} Likes</span>
                   <Typography
                   onClick={()=> handleCommentClick(item.comment)}
                     sx={{
                       marginLeft: { xs: "0px", xl: "20px" },
                       fontSize: "14px",
                       display: "flex",
                       justifyContent: "center",
                       alignItems: "center",
                       gap: 1,
                       cursor:"pointer"
                     }}
                   >
                     <img
                       src={Message}
                       alt="Message"
                       style={{ width: "23px", height: "23px" }}
                     />
                     <span>{item?.comments?.length||"0"} Comments</span>
                   </Typography>
                 </Typography>
 
                 <Box sx={{ position: "relative" }}>
                        <Typography
                          onClick={(e) => handleClick(e, item?._id)}
                          sx={{ cursor: "pointer" }}
                          className="more-btn"
                        >
                          <img
                            src={More}
                            alt="More"
                            style={{ width: "24px", height: "24px" }}
                          />
                        </Typography>

                       

                        <Menu
                          id="basic-menu"
                          anchorEl={anchorEl}
                          open={open}
                          onClose={handleClose}
                          MenuListProps={{
                            'aria-labelledby': 'basic-button',
                          }}
                          sx={{
                            '& .MuiPaper-root': {
                              color: "#EA001B",
                              fontSize: "13px",
                              fontWeight: "500",
                              fontFamily: "Heebo",
                              cursor: "pointer",
                              width: "97px",
                              height: "55px",
                              flexShrink: 0,
                              borderRadius: "12px 0px 12px 12px",
                              backgroundColor: "#FFF",
                              boxShadow: "1px 2px 16px 0px rgba(0, 0, 0, 0.10)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            },
                          }}
                          anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                          }}
                          transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                          }}
                        >

                          <MenuItem onClick={() => {
                           handleDeletePost(postID)
                          }} sx={{ fontFamily: 'Heebo', color: '#EA1D26', fontWeight: '400' }}>Delete</MenuItem>
                        </Menu>
                      
                 </Box>
               </Box>
             </Box> */}

                  <Box
                    sx={{
                      width: "100%",
                      maxWidth: "449px",
                      height: "auto",
                      flexShrink: 0,
                      borderRadius: "22px",
                      backgroundColor: "#FFF",
                      boxShadow: "1px 2px 30px 0px rgba(0, 0, 0, 0.06)",
                      display: "flex",
                      flexDirection: "column",
                      padding: "16px",
                      marginTop: "25px",
                      // overflow:'hidden',
                      marginBottom: "30px",
                    }}
                  >
                    {/* First Row: Image and Text */}
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "flex-start",
                        marginBottom: "10px",
                      }}
                    >
                      <img
                        // src={item.imgSrc}
                        src={
                          item?.userDetails?.picture
                            ? `${configuration.cdnFront}/${item?.userDetails?.picture}`
                            : UserImg
                        }
                        alt="Event"
                        style={{
                          borderRadius: "13px",
                          marginRight: "12px",
                          width: "45px",
                          height: "45px",
                          // objectFit: "cover",
                        }}
                      />
                      <Box>
                        <Typography
                          sx={{
                            fontWeight: "700",
                            fontSize: "14px",
                            color: "#362B24",
                          }}
                        >
                          {item?.userDetails?.fullname || ""}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "11px",
                            color: "#065F46",
                            fontWeight: "400",
                            marginTop: "5px",
                          }}
                        >
                          <img
                            src={Clock}
                            className="me-2"
                            style={{ fontFamily: "Heebo" }}
                          />
                          {item?.updated_at
                            ? new Date(item.updated_at).toLocaleDateString(
                                "en-GB",
                                {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                }
                              )
                            : "N/A"}
                        </Typography>
                      </Box>
                    </Box>

                    {item?.photos?.length > 0 && (
                      <Typography
                        sx={{
                          display: "flex",
                          gap: "20px",
                          borderRadius: "17px",
                          mt: "8px",
                          overflow: "hidden",
                          cursor: "pointer",
                        }}
                      >
                        {item?.photos?.length === 1 ? (
                          <img
                            src={
                              item.photos[0]?.url
                                ? `${configuration.cdnFront}/${item.photos[0]?.url}`
                                : UserImg
                            }
                            style={{
                              width: "100%",
                              height: "248px",
                              borderRadius: "17px",
                            }}
                            alt="Single"
                          />
                        ) : (
                          <Swiper
                            spaceBetween={10}
                            slidesPerView={1.4}
                            loop={true}
                            breakpoints={{
                              320: {
                                slidesPerView: 1,
                              },

                              640: {
                                slidesPerView: 0,
                              },
                              768: {
                                slidesPerView: 1.2,
                              },
                              1024: {
                                slidesPerView: 0.8,
                              },
                              1200: {
                                slidesPerView: 1,

                                spacing: 20,
                              },
                              1400: {
                                slidesPerView: 1.4,
                              },
                            }}
                          >
                            {item?.photos?.map((photo, indx) => (
                              <SwiperSlide key={indx}>
                                <img
                                  src={
                                    photo?.url
                                      ? `${configuration.cdnFront}/${photo?.url}`
                                      : UserImg
                                  }
                                  style={{
                                    width: "100%",
                                    height: "248px",
                                    borderRadius: "17px",
                                  }}
                                  alt={`slide-${indx}`}
                                />
                              </SwiperSlide>
                            ))}
                          </Swiper>
                        )}
                      </Typography>
                    )}

                    {/* Second Row: Description */}
                    <Typography
                      sx={{
                        fontSize: "12px",
                        color: "#362B24",
                        marginBottom: "10px",
                        opacity: 0.6,
                        fontFamily: "Heebo",
                        mt: "10px",
                        lineHeight: "20px",
                        maxWidth: "290px",
                        width: "100%",
                      }}
                    >
                      {item?.description || "N/A"}
                    </Typography>

                    <Box
                      sx={{
                        fontSize: "12px",
                        color: "#362B24",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        // marginBottom:'30px'
                      }}
                    >
                      <Typography
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          flexWrap: "wrap",
                          gap: 1,
                          fontFamily: "Heebo",
                          fontWeight: 400,
                          fontSize: "14px",
                        }}
                      >
                        <FavoriteIcon sx={{ color: "red" }} />
                        <span>{item?.likeCount || "0"} Likes</span>
                        <Typography
                          onClick={() => handleModalOepn(item)}
                          sx={{
                            marginLeft: { xs: "0px", xl: "20px" },
                            fontSize: "14px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: 1,
                            cursor: "pointer",
                          }}
                        >
                          <img
                            src={Message}
                            alt="Message"
                            style={{ width: "23px", height: "23px" }}
                          />
                          <span>{item?.comments.length || "0"} Comments</span>
                        </Typography>
                      </Typography>

                      <Box sx={{ position: "relative" }}>
                        <Typography
                          onClick={(e) => handleClick(e, item?._id)}
                          sx={{ cursor: "pointer" }}
                          className="more-btn"
                        >
                          <img
                            src={More}
                            alt="More"
                            style={{ width: "24px", height: "24px" }}
                          />
                        </Typography>

                        {/* Conditional Box */}

                        <Menu
                          id="basic-menu"
                          anchorEl={anchorEl}
                          open={open}
                          onClose={handleClose}
                          MenuListProps={{
                            "aria-labelledby": "basic-button",
                          }}
                          sx={{
                            "& .MuiPaper-root": {
                              color: "#EA001B",
                              fontSize: "13px",
                              fontWeight: "500",
                              fontFamily: "Heebo",
                              cursor: "pointer",
                              width: "97px",
                              height: "55px",
                              flexShrink: 0,
                              borderRadius: "12px 0px 12px 12px",
                              backgroundColor: "#FFF",
                              boxShadow: "1px 2px 16px 0px rgba(0, 0, 0, 0.10)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            },
                          }}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                        >
                          <MenuItem
                            onClick={() => {
                              handleDeletePost(postID); 
                              handleClose(); 
                            }}
                            sx={{
                              fontFamily: "Heebo",
                              color: "#EA1D26",
                              fontWeight: "400",
                            }}
                          >
                            Delete
                          </MenuItem>
                        </Menu>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            ))
          ) : (
            <div style={{ textAlign: "center" }}>No Data Found</div>
          )}
        </>
      )}

      <CommentModal
        open={commentModalOpen}
        onClose={handleModalClose}
        data={commentData}
        hasMore={hasMoreTickets}
        loadMore={loadMoreTickets}
      />
      <ForumModal
          open={opens}
          handleClose={handleForumClose}
          handleSave={handleSave}
          editingData={editingData}
      />

    </div>
  );
};

export default ModrationDetail;
